import React, { ReactElement } from 'react';
import { Control, DeepMap, FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { ControlledRadioButton } from '../../../../../../../components/Form/ControlledRadioButton';
import { ControlledTextfield } from '../../../../../../../components';
import styles from './DhcpOptionFormFields.module.css';
import { useTriggerDhcpValueValidation } from './hooks/use-trigger-dhcp-value-validation.tsx';

export interface DhcpOptionFormFieldsProps {
  watch: (arg: string) => string | boolean;
  trigger: (
    name?:
      | keyof RemoteAccessFormData
      | (keyof RemoteAccessFormData)[]
      | undefined,
  ) => Promise<boolean>;
  control: Control<RemoteAccessFormData>;
  errors: DeepMap<RemoteAccessFormData, FieldError>;
  isDhcpOption43Enabled: boolean;
}

export function DhcpOptionFormFields({
  control,
  watch,
  isDhcpOption43Enabled,
  errors,
  trigger,
}: DhcpOptionFormFieldsProps): ReactElement {
  const { t } = useTranslation();
  const dhcpType = watch('dhcpType');
  const rootClasses = classNames({
    ['displayNone']: !isDhcpOption43Enabled,
    ['flex']: isDhcpOption43Enabled,
  });
  const watchDhcpType = watch('dhcpType') as DhcpTypes;

  useTriggerDhcpValueValidation({ trigger, watchDhcpType });

  return (
    <div className={rootClasses}>
      <div className={styles.dhcpValueTypeField}>
        <ControlledRadioButton
          control={control}
          name="dhcpType"
          label={t('remoteAccess.formLabels.hex')}
          value="HEX"
          defaultValue={dhcpType === 'HEX'}
        />
        <ControlledRadioButton
          control={control}
          name="dhcpType"
          label={t('remoteAccess.formLabels.text')}
          value="TEXT"
          defaultValue={dhcpType === 'TEXT'}
        />
      </div>
      <div className="col-4 dbl-padding-left">
        <ControlledTextfield
          control={control}
          label=""
          name="dhcpValue"
          error={errors?.dhcpValue?.message}
        />
      </div>
    </div>
  );
}
